import { render, staticRenderFns } from "./clean.vue?vue&type=template&id=cc496a52&"
import script from "./clean.vue?vue&type=script&lang=js&"
export * from "./clean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports